import { gsap, ScrollTrigger } from "../app.js";

window.addEventListener('resize', function() {
    ScrollTrigger.refresh();
});

export function startAnimation() {
    // fadeinup
    // -------------------------------------------------------------------------
    function fadeinup(element, trigger, stagger = 0) {
        gsap.fromTo(
            element,
            {
                autoAlpha: 0,
                y: 20,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.4,
                stagger: stagger,
                scrollTrigger: {
                    trigger: trigger,
                    start: "top 90%",
                    end: "bottom",
                    toggleActions: "play none none none",
                },
            }
        );
    }


    // 下層ページ共通
    // -------------------------------------------------------------------------
    gsap.utils.toArray(".illumi-heading1, .illumi-heading2, .illumi-text, .illumi-text-sm").forEach((element) => {
        fadeinup(element, element);
    });


    // グリッドアイテムのアニメーションを設定
    // アニメーションのタイムラインを作成
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".illumi-instagram",
            start: "top 90%",
            toggleActions: "play none none none",
        }
    });

    // タイムラインに子要素のアニメーションを追加
    tl.from(".illumi-instagram__item", {
        autoAlpha: 0,
        duration: 0.5,
        stagger: {
            each: 0.1,
            grid: "auto",
        },
    });

    // .is-active
    // -------------------------------------------------------------------------
    gsap.utils.toArray(".illumi-deco-line").forEach(function(item) {
        gsap.to(item, {
            scrollTrigger: {
                toggleActions: "play none none none",
                trigger: item,
                start: "top 80%",
                toggleClass: "is-active",
                once: true,
            },
        });
    });


    gsap.utils.toArray(".illumi-welcome-section, .illumi-img, .illumi-btn, .illumi-box, .illumi-table, .illumi-content-heading, .illumi-table tr, .illumi-divider, .illumi-figure").forEach(function(item) {
        gsap.to(item, {
            scrollTrigger: {
                toggleActions: "play none none none",
                trigger: item,
                start: "top 90%",
                toggleClass: "is-active",
                once: true,
                // markers: true,
            },
        });
    });

    gsap.utils.toArray(".illumi-logo, .illumi-deco-line-mv").forEach(function(item) {
        gsap.to(item, {
            scrollTrigger: {
                toggleActions: "play none none none",
                trigger: item,
                start: "top 80%",
                toggleClass: "is-active",
                once: true,
            },
        });
    });
}

